import aceRequest from '../ace-request';

/**
 * Low-level communication handler for the User data service.
 * Uses Q-based promises for all operations.
 */

(function () {
  window.atex = window.atex || {};
  window.atex.aceui = window.atex.aceui || {};
  window.atex.aceui.service = window.atex.aceui.service || {};

  /**
   * Creates a new SecurityUserService object.
   *
   * @param {string} securityUserServiceUrl - The URL to the user data service in the Content REST API.
   * @param {Object} settings
   * @param {boolean} settings.cacheBusting - Whether to use cache busting strategies in requests
   *
   * @return {Object} A SecurityUserService instance.
   */
  atex.aceui.service.SecurityUserService = function (securityUserServiceUrl, { cacheBusting, adaptedAxios }) {

    return {
      /**
       * Search for users.
       *
       * @param {Object} transferInfo - a transfer info object containing request details
       * @param {string} transferInfo.token - the authorization token to use for the searcgh request
       * @param {string} transferInfo.query - a search string containing query parameters for the request
       *
       * @typedef {Object} SearchResult - The search result with a list of usernames.
       *
       * @return {Promise.<SearchResult, atex.aceui.error.Error>}
       */
      search: ({ token, querystring }) => {
        let url = `${securityUserServiceUrl}/search`;
        let params = [];

        if (querystring) {
          params.push (`query=${querystring}`);
        }

        if (cacheBusting)  {
          params.push (`cacheBusting=${Math.random().toString().substring(2)}`);
        }

        for (let i = 0; i < params.length; i++) {
          url += i ? '&' : '?';
          url += params[i];
        }

        return aceRequest ({ url, token }, adaptedAxios)
          .then ((response) => { return response.body; })
          .catch ((error) => {
            var e = atex.aceui.HTTPUtils.createError(error, 'atex.aceui.service.SecurityUserService', {
              401: 'Error while searching: User was not correctly authenticated!',
              403: 'Error while searching: Permission denied.',
              'default': 'Unknown error while searching through the Content REST API!'
            });
            e.rootCause = error.rootCause;
            return Promise.reject (e);
          });
      }
    };
  };
})();
